"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AmenityPropTypes = exports.AmenitiesCardPropTypes = void 0;

var _propTypes = require("prop-types");

var _constant = require("../Theme/constant");

var AmenityPropTypes = {
  PropTypes: {
    amenity: (0, _propTypes.shape)({
      id: _propTypes.string,
      name: _propTypes.string
    }),
    accessible: _propTypes.bool,
    iconColor: _propTypes.string,
    textColor: _propTypes.string
  },
  DefaultProps: {
    amenity: [],
    iconColor: null,
    textColor: null
  }
};
exports.AmenityPropTypes = AmenityPropTypes;
var AmenitiesCardPropTypes = {
  PropTypes: {
    title: _propTypes.string,
    amenities: _propTypes.array,
    theme: _propTypes.string,
    accessible: _propTypes.bool,
    iconColor: _propTypes.string,
    customProperties: _propTypes.object,
    subTitle: _propTypes.string,
    textColor: _propTypes.string,
    oneColumn: _propTypes.bool,
    twoColumns: _propTypes.bool
  },
  DefaultProps: {
    title: null,
    amenities: [],
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    iconColor: 'greyDark',
    subTitle: null,
    textColor: null,
    oneColumn: false,
    twoColumns: false
  }
};
exports.AmenitiesCardPropTypes = AmenitiesCardPropTypes;